<template>
  <div class="PPage" :class="[format, orientation]"><slot></slot></div>
</template>

<script>
export default {
  name: "Page",
  props: {
    format: {},
    orientation: {
      type: String,
      default: "portrait"
    }
  }
};
</script>
